import { renewEnrollmentHistoryApi } from '../api'

const getRenewEnrollmentHistory = async group_student_id => {
  try {
    const response = await renewEnrollmentHistoryApi.getRenewEnrollmentHistory(group_student_id)

    const { ok, status } = response

    if (ok && status === 200) {
      const responseBody = await response.json()

      return {
        success: true,
        payload: {
          history: responseBody.data.map(item => item.attributes),
        },
      }
    }

    if (status === 404) {
      return { success: true, payload: { history: [] } }
    }
  } catch { }

  return { success: false, payload: { history: [] } }
}

const renewEnrollmentHistoryService = {
  getRenewEnrollmentHistory,
}

export default renewEnrollmentHistoryService
